<template>
    <v-container max-width="100%" style="margin-top: 2%;">
      <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>

        <ConfirmDeleteDialog
            v-model="confirmDialog"
            :title="$t('crudMessages.dialogs.confirmDelete.title')"
            :message="$t('crudMessages.dialogs.confirmDelete.message') + deletedItem.titulo + '?'"
            :cancel-text="$t('crudMessages.dialogs.confirmDelete.cancel')"
            :confirm-text="$t('crudMessages.dialogs.confirmDelete.delete')"
            @cancel="closeDelete"
            @confirm="confirmDelete"
        />

      <PublishDialog
        ref="publishDialogComponent"
        v-model="publishDialog"
        :title="$t('crudMessages.publishAsAlert')"
        :tela-selected.sync="telaSelected"
        :banners="banners"
        :banners-filtered="bannersFiltered"
        :aviso.sync="aviso"
        :categorias-avisos="categoriasAvisos"
        :dti.sync="dti"
        :dtf.sync="dtf"
        :dti-props="dtiProps"
        :dtf-props="dtfProps"
        :time-props="timeProps"
        :text-field-props-inicio="textFieldPropsInicio"
        :text-field-props-fim="textFieldPropsFim"
        :screen-label="$t('crudMessages.screen')"
        :banner-label="$t('crudMessages.banner')"
        :category-label="$t('crudMessages.category')"
        :validity-start-label="$t('crudQuadros.form.fields.validityStart')"
        :validity-end-label="$t('crudQuadros.form.fields.validityEnd')"
                                :clear-text="$t('datetime.close')"
        :cancel-text="$t('button.cancel')"
        :publish-text="$t('button.publish')"
        :form-valid.sync="formPublishValidado"
        @cancel="closePublish"
        @publish="publicarMensagem"
      />

      <ReplaceDialog
        v-model="replaceDialog"
        :title="$t('crudMessages.vigencyConflict')"
        :message="$t('crudMessages.messages.existsVigency')"
        :warning-message="$t('crudMessages.messages.substitutionVigency')"
        :aviso-conflitante="avisoConflitante"
        :message-label="$tc('crudMessages.self', 1)"
        :start-label="$t('crudMessages.start')"
        :end-label="$t('crudMessages.end')"
        :category-label="$t('crudMessages.category')"
        :undefined-label="$t('crudMessages.undefined')"
        :cancel-text="$t('button.cancel')"
        :confirm-text="$t('button.substitute')"
        @cancel="cancelReplace"
        @confirm="confirmReplace"
      />

      <EditPublicacaoDialog
        ref="editPublicacaoDialogComponent"
        v-model="editPublicacaoDialog"
        :title="$t('crudMessages.editPublish')"
        :tela-selected.sync="telaSelectedEdit"
        :banners="banners"
        :banners-filtered="bannersFilteredEdit"
        :aviso.sync="avisoEdit"
        :categorias-avisos="categoriasAvisos"
        :dti.sync="dtiEdit"
        :dtf.sync="dtfEdit"
        :dti-props="dtiEditProps"
        :dtf-props="dtfEditProps"
        :time-props="timeProps"
        :text-field-props-inicio="textFieldPropsInicio"
        :text-field-props-fim="textFieldPropsFim"
        :screen-label="$t('crudMessages.screen')"
        :banner-label="$t('crudMessages.banner')"
        :category-label="$t('crudMessages.category')"
        :validity-start-label="$t('crudQuadros.form.fields.validityStart')"
        :validity-end-label="$t('crudQuadros.form.fields.validityEnd')"
                                :clear-text="$t('datetime.close')"
        :cancel-text="$t('button.cancel')"
        :save-text="$t('button.save')"
        :form-valid.sync="formEditPublicacaoValidado"
        @cancel="closeEditPublicacao"
        @save="salvarEdicaoPublicacao"
      />

      <ConfirmDeleteDialog
        v-model="confirmDeletePublicacaoDialog"
        :title="$t('crudTemplatesMensagens.dialogs.confirmDelete.title')"
        :message="$t('crudTemplatesMensagens.dialogs.confirmDelete.message')"
        :cancel-text="$t('crudTemplatesMensagens.dialogs.confirmDelete.cancel')"
        :confirm-text="$t('crudTemplatesMensagens.dialogs.confirmDelete.delete')"
        @cancel="closeDeletePublicacao"
        @confirm="confirmDeletePublicacao"
      />

        <EnvioDialog
            ref="envioDialogComponent"
            v-model="envioDialog"
            :title="$t('crudMessages.sendMessage')"
            :tipo-destinatario.sync="tipoDestinatario"
            :tipo-destinatario-label="$t('crudMessages.recipientType')"
            :tipos-destinatario-items="tiposDestinatarioItems"
            :tipo-destinatario-rules="[(v) => !!v || $t('crudMessages.chooseRecipientType')]"
            :grupos-selected.sync="gruposSelected"
            :pessoas-selected.sync="pessoasSelected"
            :usuarios-selected.sync="usuariosSelected"
            :usuarios-label="$t('crudMessages.users')"
            :canais="canais"
            :canais-selected.sync="canaisSelected"
            :spaces="spaces"
            :spaces-selected.sync="spacesSelected"
            :envia-mensagem-direta.sync="enviaMensagemDireta"
            :envia-mensagem-espaco.sync="enviaMensagemEspaço"
            :template="templateSelecionado"
            :groups-label="$t('nav.registration.groups')"
            :units-label="$t('nav.registration.units')"
            :clients-label="$t('nav.registration.clients')"
            :agencies-label="$t('candidate.headers.main.agency')"
            :profiles-label="$t('nav.profiles')"
            :filters-section-label="$t('system.labels.filters')"
            :receivers-label="$t('crudMessages.receiver')"
            :channels-label="$t('crudMessages.otherChannels')"
            :no-channels-message="$t('crudMessages.noChannelsEnabled')"
            :direct-messages-label="$t('crudMessages.sendDirectMessages')"
            :space-messages-label="$t('crudMessages.sendSpaceMessages')"
            :spaces-label="$t('crudMessages.googleChatSpaces')"
            :cancel-text="$t('button.cancel')"
            :send-text="$t('button.send')"
            :groups-rules="groupsRulesEnvio"
            :receivers-rules="[(v) => v.length > 0 || $t('crudMessages.chooseAtLeastOneReceiver')]"
            :spaces-rules="[spacesRules]"
            :form-valid.sync="formEnvioValidado"
            :loading.sync="loadingEnviando"
            @tipoDestinatarioChanged="tipoDestinatarioChanged"
            @error="showErrorSelect"
            @cancel="closeEnvio"
            @send="enviaMensagem"
        />

        <EnvioCredenciaisDialog
            v-model="credenciaisDialog"
            :token="token"
            :user="user"
            :setup="setup"
            modo-destinatarios="pessoas"
            :id-mensagem="credenciaisIdMensagem"
            :cod-template="credenciaisCodTemplate"
            :title="$t('credentials.dialog.title')"
            :groups-label="$t('nav.registration.groups')"
            :receivers-label="$t('credentials.dialog.receivers')"
            :channels-label="$t('credentials.dialog.channels')"
            :template-label="$t('credentials.dialog.template')"
            :template-required-message="$t('credentials.dialog.templateRequired')"
            :code-text="$t('crudTemplatesMensagens.form.fields.code')"
            :no-channels-message="$t('credentials.dialog.noChannels')"
            :cancel-text="$t('button.cancel')"
            :send-text="$t('button.send')"
            @cancel="closeCredenciais"
        />

        <merus-data-table :headers="headers" :items="mensagens" :loading="loading" :default-multi-sort="defaultSort"
            :loading-text="$t('system.messages.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="MENSAGENS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar 
                :title="$tc('crudMessages.self', 2)" 
                :token="token" 
                :items="displayedItemsForExport !== null ? displayedItemsForExport : mensagens"
                :help-dialog-items="helpItems"
                :help-dialog-intro="helpDialogIntro"
                :help-dialog-title="helpDialogTitle"
                :csv-title="$tc('crudMessages.self', 2)" 
                :pdf-title="$tc('crudMessages.self', 2)" 
                :pdf-headers="headers" 
                :pdf-filename="$tc('crudMessages.self', 2)"
                :csv-headers="headers"
                    hide-search>
                    <template v-slot:extension>
                        <v-btn
                            color="primary"
                            dark
                            small
                            class="mb-2 mr-2"
                            @click="openCredenciaisDialogToolbar"
                        >
                            <v-icon left small>mdi-email-lock-outline</v-icon>
                            {{ $t('credentials.sendButton') }}
                        </v-btn>
                    </template>
                    <template v-slot:add v-if="canInsert">
                        <EditMensagemDialog
                            ref="editMensagemDialogComponent"
                            v-model="editDialog"
                            :title="$tc('crudMessages.self', 1)"
                            :edited-item.sync="editedItem"
                            :templates="templates"
                            :envios-mensagem="enviosMensagem"
                            :publicacoes-mensagem="publicacoesMensagem"
                            :headers-envio="headersEnvio"
                            :headers-publicacao="headersPublicacao"
                            :default-sort-envio="defaultSortEnvio"
                            :default-sort-publicacao="defaultSortPublicacao"
                            :loading-envios-mensagem="loadingEnviosMensagem"
                            :loading-publicacoes-mensagem="loadingPublicacoesMensagem"
                            :token="token"
                            :title-label="$t('table.title')"
                            :header-label="$tc('crudMessages.header', 1)"
                            :body-label="$tc('crudMessages.self', 1)"
                            :footer-label="$tc('crudMessages.footer', 1)"
                            :automatic-label="$t('crudMessages.automatic')"
                            :footer-hint="$t('crudMessages.footerHint')"
                            :use-template-label="$t('crudMessages.useTemplate')"
                            :template-label="$t('crudMessages.selectTemplate')"
                            :code-text="$t('crudTemplatesMensagens.form.fields.code')"
                            :delivery-title="$t('crudMessages.deliveries')"
                            :publishes-title="$t('crudMessages.publishes')"
                            :loading-text="$t('system.messages.loading')"
                            :save-text="$t('button.save')"
                            :whatsapp-disponivel="setup.has_whatsapp == 1"
                            :whatsapp-unavailable-message="$t('crudMessages.whatsappUnavailable')"
                            :variable-text="$t('crudTemplatesMensagens.form.variable')"
                            :template-without-name="$t('crudMessages.templateWithoutName')"
                            :form-valid.sync="formMensagemValidado"
                            @close="closeEdit"
                            @save="save"
                            @edit-publicacao="editPublicacao"
                            @delete-publicacao="deletePublicacao"
                            @template-selected="applyTemplate"
                        />
                    </template>
                </CadastroToolbar>
            </template>

            <template v-slot:item.corpo="{ item }">
                <div class="truncate">{{ item.corpo }}</div>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>

        <v-icon small class="mr-2" color="orange" @click="sendItem(item)" 
            :disabled="isSendDisabled(item)" >mdi-email-arrow-right</v-icon
        >

        <v-icon small class="mr-2" color="blue" @click="publishItem(item)"
            >mdi-alert-plus</v-icon
        >

                <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
                    :disabled="item.enviada == 1 || !canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import LoadingComponent from "./LoadingComponent.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue"
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue"
import ConfirmDeleteDialog from "./Dialogs/ConfirmDeleteDialog.vue"
import PublishDialog from "./Dialogs/PublishDialog.vue"
import EditPublicacaoDialog from "./Dialogs/EditPublicacaoDialog.vue"
import ReplaceDialog from "./Dialogs/ReplaceDialog.vue"
import EnvioDialog from "./Dialogs/EnvioDialog.vue"
import EnvioCredenciaisDialog from "./Dialogs/EnvioCredenciaisDialog.vue"
import EditMensagemDialog from "./Dialogs/EditMensagemDialog.vue"
import EventBus from '../utils/eventBus';
import translateDbField from "@/utils/translateDbField";

export default {
    components: {
      LoadingComponent,
      MerusDataTable,
      CadastroToolbar,
      ConfirmDeleteDialog,
      PublishDialog,
      EditPublicacaoDialog,
      ReplaceDialog,
      EnvioDialog,
      EnvioCredenciaisDialog,
      EditMensagemDialog
    },
    data: () => ({
    headers: [],
        user: null,
        displayedItemsForExport: null,
        token: null, 
        loading: false,
        loadingDestinatarios: false,
        loadingEnviosMensagem: false,
        loadingEnviando: false,
        loadingPublicacoesMensagem: false,
        search: "",
        searchEnvios: "",
        editDialog: false,
        confirmDialog: false,
        envioDialog: false,
        credenciaisDialog: false,
        credenciaisIdMensagem: null,
        credenciaisCodTemplate: 'SYS-CRED',
        formMensagemValidado: false,
        formEnvioValidado: false,
        canais: [],
        canaisSelected: [],
        gruposSelected: [],
        pessoasSelected: [],
        tipoDestinatario: 'passageiros',
        usuariosSelected: [],
        mensagens: [],
        templates: [],
        templateSelecionado: null,
        enviosMensagem: [],
        publicacoesMensagem: [],
        spaces: [],
        spacesSelected: [],
        enviaMensagemDireta: false, 
        enviaMensagemEspaço: false, 
        publishDialog: false,
        replaceDialog: false,
        editPublicacaoDialog: false,
        confirmDeletePublicacaoDialog: false,
        formPublishValidado: false,
        formEditPublicacaoValidado: false,
        telaSelected: null,
        telaSelectedEdit: null,
        banners: [],
        categoriasAvisos: [],
        avisoConflitante: null,
        dti: null,
        dtf: null,
        dtiEdit: null,
        dtfEdit: null,
        textFieldPropsFim: {
            prependInnerIcon: "mdi-calendar",
        },
        timeProps: {
          useSeconds: true,
        },
        editedIndex: -1, 
        editedItem: {
            id_mensagem: null,
            titulo: null,
            descricao: null,
            campos_descricao: null,
            corpo: null,
            campos_corpo: null,
            rodape: null,
            id_template: null,
            automatica: false,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            titulo_anterior: null,
            corpo_anterior: null,
            enviada: null,
            enviada_extenso: null,
            contagem_erros: null
        },
        defaultItem: {
            id_mensagem: null,
            titulo: null,
            descricao: null,
            campos_descricao: null,
            corpo: null,
            campos_corpo: null,
            rodape: null,
            id_template: null,
            automatica: false,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            titulo_anterior: null,
            corpo_anterior: null,
            enviada: null,
            enviada_extenso: null,
            contagem_erros: null
        },
        deletedItem: {
            id_mensagem: null,
            titulo: null,
            descricao: null,
            campos_descricao: null,
            corpo: null,
            campos_corpo: null,
            rodape: null,
            id_template: null,
            automatica: false,
            dt_inclusao: null,
            dt_inclusao_extenso: null,
            id_usuario_inclusao: null,
            usuario_inclusao: null,
            dt_ultima_alteracao: null,
            dt_ultima_alteracao_extenso: null,
            id_usuario_ultima_alteracao: null,
            usuario_ultima_alteracao: null,
            titulo_anterior: null,
            corpo_anterior: null,
            enviada: null,
            enviada_extenso: null,
            contagem_erros: null
        },
        aviso: {
            id_aviso: null, 
            id_banner: null,
            id_mensagem: null, 
            id_categoria_aviso: null,
            dt_inicio_vigencia: null, 
            dt_fim_vigencia: null,
            dt_publicacao: null,
            id_usuario_publicacao: null,
        },
        defaultAviso: {
            id_aviso: null, 
            id_banner: null,
            id_mensagem: null, 
            id_categoria_aviso: null,
            dt_inicio_vigencia: null, 
            dt_fim_vigencia: null,
            dt_publicacao: null,
            id_usuario_publicacao: null,
        },
        avisoEdit: {
            id_aviso: null, 
            id_banner: null,
            id_mensagem: null, 
            id_categoria_aviso: null,
            dt_inicio_vigencia: null, 
            dt_fim_vigencia: null,
            dt_publicacao: null,
            id_usuario_publicacao: null,
        },
        defaultAvisoEdit: {
            id_aviso: null, 
            id_banner: null,
            id_mensagem: null, 
            id_categoria_aviso: null,
            dt_inicio_vigencia: null, 
            dt_fim_vigencia: null,
            dt_publicacao: null,
            id_usuario_publicacao: null,
        },
        publicacaoParaDeletar: null,
        setup: {
            has_google_chat: 0,
            has_email: 0,
            has_whatsapp: 0,
            has_sms: 0,
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {
        headersPublicacao() {
            return [
            { text: this.$t('crudMessages.banner'), value: "descricao_banner", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.date'), value: "dt_publicacao_extenso", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.vigencyStart'), value: "dt_inicio_vigencia_extenso", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.vigencyEnd'), value: "dt_fim_vigencia_extenso", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.user'), value: "usuario_publicacao", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.category'), value: "descricao_categoria", sortable: true, filtrable: true },
            { text: this.$t('crudMessages.headers.actions'), value: "actions", sortable: false, filtrable: false }];
        },
        helpItems() {
            const items = [
                {
                    title: this.$t('crudMessages.help.items.guidelines.title'),
                    description: this.$t('crudMessages.help.items.guidelines.description') 
                }
            ];
            
            return items;
        },
        helpDialogIntro() {
            return this.$t('crudMessages.help.intro');
        },
        helpDialogTitle() {
            return this.$t('crudMessages.help.title');
        },
        defaultSortPublicacao() {
            return [
            { value: 'dt_publicacao', options: { text: this.$t('system.labels.decreasing'), value: -1} }];
        },
        textFieldPropsInicio() {
            return {
            prependInnerIcon: "mdi-calendar",
            rules: [(v) => !!v || this.$t('rules.messageDate')],
            };
        },
        defaultSort() {
            return [
                { value: 'dt_inclusao', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        defaultSortEnvio() {
            return [
                { value: 'nome_destinatario', options: { text: this.$t('system.labels.increasing'), value: 1 } },
                { value: 'dt_inclusao', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        spacesRules() {
            if (this.enviaMensagemEspaço) {
                return this.spacesSelected.length > 0 || this.$t('crudMessages.selectAtLeastOneSpace');
            }
            return true;
        },
        groupsRulesEnvio() {
            if (this.tipoDestinatario !== 'passageiros') {
                return [];
            }
            return [(v) => v.length > 0 || this.$t('crudMessages.chooseAtLeastOneGroup')];
        },
        tiposDestinatarioItems() {
            return [
                { text: this.$t('crudMessages.recipientTypes.passengers'), value: 'passageiros' },
                { text: this.$t('crudMessages.recipientTypes.users'), value: 'usuarios' },
            ];
        },
        loadingMessage() {
            return this.$t('system.messages.loading');
        },
        headersEnvio() {
            return [
                { text: this.$t('crudMessages.receiver'), value: "nome_destinatario", sortable: true, filtrable: true },
                { text: this.$t('table.channel'), value: "descricao_canal", sortable: true, filtrable: true },
                { text: this.$t('table.sent'), value: "enviada_extenso", sortable: true, filtrable: true },
                { text: this.$t('table.shipmentDate'), value: "dt_envio_extenso", sortable: true, filtrable: true },
                { text: this.$t('table.error'), value: "descricao_erro_envio", sortable: false, filtrable: true }];
        },
    today() {
            return new Date().toISOString().substring(0,10);
        },
        dtiProps() {
            return {
                min: this.today
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
                } else {
                    min = this.dti.toISOString().substring(0,10);
                }
            }
            return {
                min: min,
            }
        },
        dtiEditProps() {
            return {
                min: this.today
            }
        },
        dtfEditProps() {
            let min = null;
            if (this.dtiEdit) {
                if (typeof this.dtiEdit === 'string') {
                    min = `${this.dtiEdit.substring(6,10)}-${this.dtiEdit.substring(3,5)}-${this.dtiEdit.substring(0,2)}`;
                } else {
                    min = this.dtiEdit.toISOString().substring(0,10);
                }
            }
            return {
                min: min,
            }
        },
        bannersFiltered() {
            if (this.telaSelected) {
                return this.banners.filter((b) => b.id_recurso == this.telaSelected);
            }

            return [];
        },
        bannersFilteredEdit() {
            if (this.telaSelectedEdit) {
                return this.banners.filter((b) => b.id_recurso == this.telaSelectedEdit);
            }

            return [];
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.envioDialogComponent) {
                this.$refs.envioDialogComponent.resetValidation();
            }
            if (this.$refs.editMensagemDialogComponent) {
                this.$refs.editMensagemDialogComponent.resetValidation();
            }
            if (this.$refs.publishDialogComponent) {
                this.$refs.publishDialogComponent.resetValidation();
            }
            if (this.$refs.editPublicacaoDialogComponent) {
                this.$refs.editPublicacaoDialogComponent.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    methods: {

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatemensagem");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertmensagem");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletemensagem");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            this.populaSetup();
            this.populaMensagens();
            this.populaBanners();
            this.populaCategoriasAvisos();
            this.populaTemplates();
        },
        populaSetup() {
            apiController.request(apiController.endpoints.getallParametrossetup, {
                silent: true,
                onSuccess: (response) => {
                    this.setup = Object.assign({}, response.data[0]);
                    if (this.setup.has_google_chat == 1) {
                        this.populaSpaces();
                    }
                    // Carrega canais apenas após obter as configurações do setup
                    this.populaCanais();
                },
                onError: (e) => {
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        populaMensagens() {
            let dtf = DateUtils.getDateSQLFormatted(new Date());
            let dti = new Date();
            dti.setMonth(dti.getMonth() - 1);
            dti = DateUtils.getDateSQLFormatted(dti);

            apiController.request(apiController.endpoints.getMensagenspordatainclusao, {
                params: { dti, dtf },
                onSuccess: (response) => {
                    this.mensagens = response.data;
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                },
            });
        },
        populaCanais() {
            apiController.request(apiController.endpoints.getallCanaiscomunicacao, {
                onSuccess: (response) => {
                    // Filtra canais baseado nas configurações do setup
                    const canaisAtivos = response.data.filter(canal => {
                        // id_canal 1 = Sistema (sempre ativo, mas não aparece na lista)
                        // id_canal 2 = SMS
                        // id_canal 3 = Email  
                        // id_canal 4 = Google Chat
                        // id_canal 5 = WhatsApp
                        
                        switch(canal.id_canal) {
                            case 2: // SMS
                                return this.setup.has_sms == 1;
                            case 3: // Email
                                return this.setup.has_email == 1;
                            case 4: // Google Chat
                                return this.setup.has_google_chat == 1;
                            case 5: // WhatsApp
                                return this.setup.has_whatsapp == 1;
                            default:
                                return true; // Outros canais aparecem por padrão
                        }
                    });
                    
                    // Aplica tradução aos canais
                    this.canais = canaisAtivos.map(canal => {
                        return {
                            ...canal,
                            descricao_canal: translateDbField(
                                canal.translation_key,
                                canal.descricao_canal
                            )
                        };
                    });
                },
            });
        },
        populaSpaces() {
            apiController.request(apiController.endpoints.googleListspaces, {
                onSuccess: (response) => {
                    if (!response.data.erro) {
                        this.spaces = response.data.spaces;
                    }
                },
            });
        },
        populaEnviosMensagem() {
            this.loadingEnviosMensagem = true;
            apiController.request(apiController.endpoints.getEnviosmensagemporid, {
                params: { id: this.editedItem.id_mensagem },
                onSuccess: (response) => {
                    // Aplica tradução aos envios de mensagem
                    this.enviosMensagem = response.data.map(envio => {
                        return {
                            ...envio,
                            descricao_canal: translateDbField(
                                envio.translation_key,
                                envio.descricao_canal
                            )
                        };
                    });
                    this.loadingEnviosMensagem = false;
                },
                onError: () => {
                    this.loadingEnviosMensagem = false;
                },
            });
        },
        populaPublicacoesMensagem() {
            this.loadingPublicacoesMensagem = true;
            apiController.request(apiController.endpoints.getPublicacoesmensagemporid, {
                params: { id: this.editedItem.id_mensagem },
                onSuccess: (response) => {
                    this.publicacoesMensagem = response.data;
                    this.loadingPublicacoesMensagem = false;
                },
                onError: () => {
                    this.loadingPublicacoesMensagem = false;
                },
            });
        },
        populaBanners() {
            apiController.request(apiController.endpoints.getallBanners, {
                silent: true,
                onSuccess: (response) => {
                    this.banners = response.data;
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        populaCategoriasAvisos() {
            apiController.request(apiController.endpoints.getallCategoriasavisos, {
                silent: true,
                onSuccess: (response) => {
                    this.categoriasAvisos = response.data;
                    this.categoriasAvisos.forEach(categoria => {
                        categoria.descricao_categoria = translateDbField(
                            categoria.translation_key,
                            categoria.descricao_categoria
                        );
                        return categoria;
                    });
                },
                onError: (e) => {
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        populaTemplates() {
            apiController.request(apiController.endpoints.getallTemplatesmensagens, {
                onSuccess: (response) => {
                    this.templates = response.data;
                },
            });
        },
        applyTemplate(template) {
            // Preenche os campos da mensagem com os dados do template
            this.editedItem.titulo = template.titulo || '';
            this.editedItem.descricao = template.descricao || '';
            this.editedItem.campos_descricao = template.campos_descricao || null;
            this.editedItem.corpo = template.corpo || '';
            this.editedItem.campos_corpo = template.campos_corpo || null;
            this.editedItem.rodape = template.rodape || '';
            // Guarda o id do template para manter a relação
            this.editedItem.id_template = template.id_template;
        },
        editItem(item) {
            this.editedIndex = this.mensagens.findIndex((m) => m.id_mensagem == item.id_mensagem);
            this.editedItem = Object.assign({}, item);
            // Converte 0/1 para false/true para o v-switch
            this.editedItem.automatica = this.editedItem.automatica == 1 || this.editedItem.automatica === true;
            this.populaEnviosMensagem();
            this.populaPublicacoesMensagem();
            this.editDialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.confirmDialog = true;
        },
        sendItem(item) {
            this.editedIndex = this.mensagens.findIndex((m) => m.id_mensagem == item.id_mensagem);
            this.editedItem = Object.assign({}, item);

            const template = this.templates.find((t) => t.id_template === item.id_template)
                || this.templates.find((t) => t.titulo === item.titulo);

            if (template && template.cod_template === 'SYS-CRED') {
                this.credenciaisIdMensagem = item.id_mensagem;
                this.credenciaisCodTemplate = template.cod_template;
                this.credenciaisDialog = true;
                return;
            }

            this.templateSelecionado = template;
            this.envioDialog = true;
        },
        openCredenciaisDialogToolbar() {
            this.credenciaisIdMensagem = null;
            this.credenciaisCodTemplate = 'SYS-CRED';
            this.credenciaisDialog = true;
        },
        closeCredenciais() {
            this.credenciaisIdMensagem = null;
            this.credenciaisDialog = false;
        },
        publishItem(item) {
            this.aviso.id_mensagem = item.id_mensagem;
            this.publishDialog = true;
        },
        save() {
            if (this.$refs.editMensagemDialogComponent) {
                this.$refs.editMensagemDialogComponent.validate();
            }
            if (this.formMensagemValidado) {
                // Converte boolean para 0/1 antes de enviar para o backend
                const automatica = this.editedItem.automatica ? 1 : 0;
                
                if (this.editedIndex === -1) {
                    this.editedItem.automatica = automatica;
                    this.editedItem.id_usuario_inclusao = this.user;

                    apiController.request(apiController.endpoints.insertMensagem, {
                        data: this.editedItem,
                        onSuccess: () => {
                            this.populaMensagens();
                            this.closeEdit();
                        },
                    });
                } else {
                    this.editedItem.automatica = automatica;
                    this.editedItem.id_usuario_ultima_alteracao = this.user;

                    const mensagemOriginal = this.mensagens[this.editedIndex];
                    this.editedItem.titulo_anterior = mensagemOriginal.titulo;
                    this.editedItem.corpo_anterior = mensagemOriginal.corpo;

                    apiController.request(apiController.endpoints.updateMensagem, {
                        data: this.editedItem,
                        onSuccess: () => {
                            this.populaMensagens();
                            this.closeEdit();
                        },
                    });
                }
            }
        },
        getCanalId(canalId) {
            // Mapeia o ID do canal selecionado para o ID correto baseado na descrição/código
            // Isso garante que mesmo se os IDs no banco estiverem trocados, o código funcionará
            const canalInfo = this.canais.find(canal => canal.id_canal === canalId);
            if (!canalInfo) {
                return canalId; // Se não encontrar, retorna o ID original
            }
            
            // Mapeia baseado no código do canal para garantir o ID correto
            const codigoCanal = canalInfo.cod_canal;
            switch(codigoCanal) {
                case 'SMS':
                    return 2; // id_canal 2 = SMS
                case 'Email':
                    return 3; // id_canal 3 = Email
                case 'GoogleChat':
                    return 4; // id_canal 4 = Google Chat
                case 'WhatsApp':
                    return 5; // id_canal 5 = WhatsApp
                default:
                    return canalId; // Retorna o ID original se não reconhecer
            }
        },
        async enviaMensagem() {
            this.canaisSelected.push(1);

            if (this.$refs.envioDialogComponent) {
                this.$refs.envioDialogComponent.validate();
            }

            if (!this.formEnvioValidado) {
                this.loadingEnviando = false;
                return;
            }

            this.loadingEnviando = true;
            let msgs = [];

            if (this.tipoDestinatario === 'usuarios') {
                this.usuariosSelected.forEach((idUsuario) => {
                    this.canaisSelected.forEach((c) => {
                        const idCanal = this.getCanalId(c);
                        msgs.push({
                            idMensagem: this.editedItem.id_mensagem,
                            idUsuario: idUsuario,
                            idCanal: idCanal,
                            idUsuarioEnvio: this.user,
                        });
                    });
                });
            } else {
                this.pessoasSelected.forEach((p) => {
                    this.canaisSelected.forEach((c) => {
                        const idCanal = this.getCanalId(c);
                        msgs.push({
                            idMensagem: this.editedItem.id_mensagem,
                            idPessoa: p,
                            idCanal: idCanal,
                            idUsuarioEnvio: this.user,
                        });
                    });
                });
            }

            if (this.spacesSelected.length > 0 && this.enviaMensagemEspaço) {
                this.spacesSelected.map((s) => {
                    msgs.map((b) => {
                        if (b.idCanal === 4) {
                            b.idSpace = s;
                        }
                        return b;
                    })
                })
            }

            let payload = { mensagens: msgs, options: { googleChat: { enviaMsgDireta: this.enviaMensagemDireta } } }

            apiController.request(apiController.endpoints.enviamensagensbulk, {
                data: payload,
                onSuccess: () => {
                    this.loadingEnviando = false;
                     if (this.canaisSelected.length == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('messages.success.noOtherChannelSelected'), tipo: 'success' });
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('crudTemplatesMensagens.messageSent'), tipo: 'success' });
                    }
                    EventBus.$emit('scheduler-download-enqueued');
                    this.populaMensagens();
                    this.closeEnvio();
                },
                onError: () => {
                    this.loadingEnviando = false;
                },
            });
        },
        closeEdit() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            if (this.$refs.editMensagemDialogComponent) {
                this.$refs.editMensagemDialogComponent.resetValidation();
            }
            this.editDialog = false;
        },
        closeDelete() {
            this.deletedItem = Object.assign({}, this.defaultItem);
            this.confirmDialog = false;
        },
        closeEnvio() {
            this.loadingEnviando = false;
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.canaisSelected = [];
            this.gruposSelected = [];
            this.pessoasSelected = [];
            this.usuariosSelected = [];
            this.tipoDestinatario = 'passageiros';
            this.spacesSelected = [];
            this.templateSelecionado = null;
            if (this.$refs.envioDialogComponent) {
                this.$refs.envioDialogComponent.resetSelects();
                this.$refs.envioDialogComponent.resetValidation();
            }
            this.envioDialog = false;
        },
        closePublish() {
            this.aviso = Object.assign({}, this.defaultAviso);
            this.telaSelected = null;
            this.dti = null;
            this.dtf = null;
            this.avisoConflitante = null;
            this.replaceDialog = false;
            if (this.$refs.publishDialogComponent) {
                this.$refs.publishDialogComponent.clearDtiInput();
                this.$refs.publishDialogComponent.clearDtfInput();
                this.$refs.publishDialogComponent.resetValidation();
            }
            this.publishDialog = false;
        },
        publicarMensagem() {
            if (this.$refs.publishDialogComponent) {
                this.$refs.publishDialogComponent.validate();
            }

            if (this.formPublishValidado) {
                this.aviso.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(this.dti);
                this.aviso.dt_fim_vigencia = DateUtils.getDateSQLFormatted(this.dtf);
                this.aviso.id_usuario_publicacao = this.user;
                
                // Verifica se há conflito de vigência antes de publicar
                apiController.request(apiController.endpoints.verificaconflitovigencia, {
                    data: {
                        id_banner: this.aviso.id_banner,
                        dt_inicio_vigencia: this.aviso.dt_inicio_vigencia,
                        dt_fim_vigencia: this.aviso.dt_fim_vigencia
                    },
                    silent: true,
                    onSuccess: (response) => {
                        if (response.data && response.data.length > 0) {
                            // Há conflito - mostrar diálogo de confirmação
                            this.avisoConflitante = response.data[0];
                            this.replaceDialog = true;
                        } else {
                            // Não há conflito - inserir normalmente
                            this.inserirNovaPublicacao();
                        }
                    },
                    onError: (e) => {
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        inserirNovaPublicacao() {
            apiController.request(apiController.endpoints.insertAvisobanner, {
                data: this.aviso,
                onSuccess: () => {
                    EventBus.$emit('show-alert', { mensagem: this.$t('crudMessages.publishSuccess'), tipo: 'success' });
                    this.populaMensagens();
                    this.closePublish();
                },
            });
        },
        atualizarPublicacaoExistente() {
            // Atualiza a publicação existente com as novas datas e categoria
            const avisoAtualizado = {
                id_aviso: this.avisoConflitante.id_aviso,
                dt_inicio_vigencia: this.aviso.dt_inicio_vigencia,
                dt_fim_vigencia: this.aviso.dt_fim_vigencia,
                id_categoria_aviso: this.aviso.id_categoria_aviso,
                id_usuario_publicacao: this.user
            };

            apiController.request(apiController.endpoints.updateAvisobanner, {
                data: avisoAtualizado,
                onSuccess: () => {
                    EventBus.$emit('show-alert', { mensagem: this.$t('crudMessages.vigencyPublishUpdated'), tipo: 'success' });
                    this.populaMensagens();
                    this.closePublish();
                },
            });
        },
        confirmReplace() {
            // Usuário confirmou substituição - atualizar ao invés de inserir
            this.replaceDialog = false;
            this.atualizarPublicacaoExistente();
        },
        cancelReplace() {
            // Usuário cancelou - voltar para o diálogo de publicação
            this.replaceDialog = false;
            this.avisoConflitante = null;
        },
        podeEditarPublicacao(publicacao) {
            // Só pode editar publicações cuja vigência ainda não terminou
            // Se dt_fim_vigencia é NULL, está vigente indefinidamente (pode editar)
            // Se dt_fim_vigencia >= NOW(), ainda não terminou (pode editar)
            if (!publicacao.dt_fim_vigencia) {
                return true;
            }
            
            const dtFim = new Date(publicacao.dt_fim_vigencia);
            const agora = new Date();
            return dtFim >= agora;
        },
        podeDeletarPublicacao(publicacao) {
            // Não pode deletar publicações que já estão vigentes
            // Se dt_inicio_vigencia <= NOW(), já está vigente (não pode deletar)
            const dtInicio = new Date(publicacao.dt_inicio_vigencia);
            const agora = new Date();
            return dtInicio > agora;
        },
        isSendDisabled(item) {
            // Desabilita o envio se a mensagem tem um template da Meta que não está aprovado
            if (!item.id_template) {
                return false; // Se não tem template, pode enviar
            }
            
            // Busca o template correspondente
            const template = this.templates.find(t => t.id_template === item.id_template);
            
            if (!template) {
                return false; // Se não encontrou o template, permite enviar (pode ser template antigo ou removido)
            }
            
            // Se o template é da Meta (sent_meta = true) e não está aprovado, desabilita
            if (template.sent_meta && template.status !== 'APPROVED') {
                return true;
            }
            
            return false;
        },
        editPublicacao(publicacao) {
            // Carrega os dados da publicação para edição
            this.avisoEdit = Object.assign({}, publicacao);
            
            // Converte as datas para o formato esperado pelo datetime-picker
            if (publicacao.dt_inicio_vigencia) {
                this.dtiEdit = new Date(publicacao.dt_inicio_vigencia);
            }
            if (publicacao.dt_fim_vigencia) {
                this.dtfEdit = new Date(publicacao.dt_fim_vigencia);
            }
            
            // Encontra o id_recurso (tela) correspondente ao banner
            const banner = this.banners.find(b => b.id_banner == publicacao.id_banner);
            if (banner) {
                this.telaSelectedEdit = banner.id_recurso;
            }
            
            this.editPublicacaoDialog = true;
        },
        deletePublicacao(publicacao) {
            this.publicacaoParaDeletar = publicacao;
            this.confirmDeletePublicacaoDialog = true;
        },
        closeEditPublicacao() {
            this.avisoEdit = Object.assign({}, this.defaultAvisoEdit);
            this.telaSelectedEdit = null;
            this.dtiEdit = null;
            this.dtfEdit = null;
            if (this.$refs.editPublicacaoDialogComponent) {
                this.$refs.editPublicacaoDialogComponent.clearDtiInput();
                this.$refs.editPublicacaoDialogComponent.clearDtfInput();
                this.$refs.editPublicacaoDialogComponent.resetValidation();
            }
            this.editPublicacaoDialog = false;
        },
        closeDeletePublicacao() {
            this.publicacaoParaDeletar = null;
            this.confirmDeletePublicacaoDialog = false;
        },
        salvarEdicaoPublicacao() {
            if (this.$refs.editPublicacaoDialogComponent) {
                this.$refs.editPublicacaoDialogComponent.validate();
            }

            if (this.formEditPublicacaoValidado) {
                const dtInicioFormatada = DateUtils.getDateSQLFormatted(this.dtiEdit);
                const dtFimFormatada = DateUtils.getDateSQLFormatted(this.dtfEdit);
                
                // Verifica se há conflito de vigência (excluindo esta publicação da verificação)
                apiController.request(apiController.endpoints.verificaconflitovigencia, {
                    data: {
                        id_banner: this.avisoEdit.id_banner,
                        dt_inicio_vigencia: dtInicioFormatada,
                        dt_fim_vigencia: dtFimFormatada,
                        id_aviso_excluir: this.avisoEdit.id_aviso
                    },
                    silent: true,
                    onSuccess: (response) => {
                        if (response.data && response.data.length > 0) {
                            EventBus.$emit('show-alert', { mensagem: this.$t('crudMessages.publishConflict'), tipo: 'error' });
                        } else {
                            // Não há conflito - atualizar
                            const avisoAtualizado = {
                                id_aviso: this.avisoEdit.id_aviso,
                                dt_inicio_vigencia: dtInicioFormatada,
                                dt_fim_vigencia: dtFimFormatada,
                                id_categoria_aviso: this.avisoEdit.id_categoria_aviso,
                                id_usuario_publicacao: this.user
                            };

                            apiController.request(apiController.endpoints.updateAvisobanner, {
                                data: avisoAtualizado,
                                onSuccess: () => {
                                    EventBus.$emit('show-alert', { mensagem: this.$t('crudMessages.publishUpdated'), tipo: 'success' });
                                    this.populaPublicacoesMensagem();
                                    this.populaMensagens();
                                    this.closeEditPublicacao();
                                },
                            });
                        }
                    },
                    onError: (e) => {
                        this.sysError = e;
                        this.authDialog = true;
                    },
                });
            }
        },
        confirmDeletePublicacao() {
            apiController.request(apiController.endpoints.deleteAvisobanner, {
                data: { id_aviso: this.publicacaoParaDeletar.id_aviso, user: this.user },
                onSuccess: () => {
                    EventBus.$emit('show-alert', { mensagem: this.$t('crudMessages.deletePublish'), tipo: 'success' });
                    this.populaPublicacoesMensagem();
                    this.closeDeletePublicacao();
                },
            });
        },
        confirmDelete() {
            apiController.request(apiController.endpoints.deleteMensagem, {
                data: this.deletedItem,
                onSuccess: () => {
                    this.populaMensagens();
                    this.closeDelete();
                },
            });
        },
        tipoDestinatarioChanged() {
            this.gruposSelected = [];
            this.pessoasSelected = [];
            this.usuariosSelected = [];
            if (this.$refs.envioDialogComponent) {
                this.$refs.envioDialogComponent.resetSelects();
            }
        },
        showErrorSelect(e) {
            EventBus.$emit('show-alert', { mensagem: e, tipo: 'error' });
        }
    }
}
</script>

<style scoped>
.truncate {
    max-width: 25vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>